const PRODUCTION_HOSTS = ['instacarrier.eu', 'www.instacarrier.eu']

export function landingUrl(path = '/'): string {
  const base = PRODUCTION_HOSTS.includes(window.location.hostname)
    ? 'https://swida.sk'
    : 'https://stage.landing.swida.sk'

  return `${base}${path}`
}
